module.exports = __webpack_public_path__ + "img/bride2be.d74fc7a8.webp";